import React from 'react';
import { Mail } from 'lucide-react';

export function VirtualAdoptionContact() {
  return (
    <div className="mt-16 bg-accessible-red-600 rounded-lg p-8 text-white">
      <div className="flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex items-center gap-4">
          <Mail className="w-12 h-12" aria-hidden="true" />
          <div>
            <h2 className="heading-3-white mb-2">
              Chcesz zostać wirtualnym opiekunem?
            </h2>
            <p className="body-medium-white">
              Napisz do nas i dowiedz się więcej
            </p>
          </div>
        </div>
        <a 
          href="mailto:znajdki2012@gmail.com"
          aria-label="Napisz do nas, aby zostać wirtualnym opiekunem"
          className="bg-white text-accessible-red-600 px-8 py-4 rounded-lg btn-text-medium hover:bg-accessible-gray-50 transition-colors flex items-center gap-2"
        >
          <Mail className="w-5 h-5" aria-hidden="true" />
          <span>znajdki2012@gmail.com</span>
        </a>
      </div>
    </div>
  );
}